if (process.env.NODE_ENV === 'production') {
    module.exports = require('./z-shop-ui.production.js');
} else {
    module.exports = require('./z-shop-ui.development.js');
}




//////////////////
// WEBPACK FOOTER
// ./~/z-shop-ui/dist/z-shop-ui.js
// module id = 376
// module chunks = 0